import { useState, useEffect } from 'react';
import { Flex, theme } from '../../component-library';
import { MainPanel, PatientSidePanel } from '../../components';
import {
  ScreenCalibration,
  CalibrationCard,
  CalibrationRuler,
  EndOfTest,
  Holding,
  BlindSpot,
  Logmar,
  RandomE,
  KaysOptotypes,
  OptimaChart,
  ContrastSensitivity,
  VisualField,
  VisualFieldTwo,
  VisualFieldForthValley,
  Refraction,
  PupillaryDistance,
  CameraCalibration,
  KaysMultipleOptotypes,
  RefractionTwo,
  BlindspotCameraCalibration,
  ColourVisionPlate,
} from '.';

const MainPanelContent = ({
  postMessage,
  activeTab,
  setActiveTab,
  blindSpotData,
  setBlindSpotData,
  movementNotification,
  logmarData,
  logmarType,
  optimaData,
  visualFieldTestControl,
  testNotification,
  blindSpotUpdateMessage,
  setBlindSpotUpdateMessage,
}) => {
  const [title, setTitle] = useState('');

  useEffect(() => {
    if (activeTab === 'calibration-selection') setTitle('Calibration Selection');
    if (activeTab === 'camera-calibration') setTitle('Calibrate your camera');
    if (activeTab === 'blindspot-camera-calibration') setTitle('Calibrate your camera');
    if (activeTab === 'screen-calibration' || activeTab === 'card' || activeTab === 'ruler') setTitle('Set Screen Size');
    if (activeTab === 'holding') setTitle('Test Beginning');
  }, [setTitle, activeTab]);

  const contentOptions = [
    {
      id: 'screen-calibration',
      content: <ScreenCalibration postMessage={postMessage} setStep={setActiveTab} />,
    },
    {
      id: 'camera-calibration',
      content: <CameraCalibration postMessage={postMessage} setStep={setActiveTab} />,
    },
    {
      id: 'blindspot-camera-calibration',
      content: <BlindspotCameraCalibration postMessage={postMessage} setStep={setActiveTab} />,
    },
    {
      id: 'card',
      content: <CalibrationCard setActiveTab={setActiveTab} postMessage={postMessage} />,
    },
    {
      id: 'ruler',
      content: <CalibrationRuler setActiveTab={setActiveTab} postMessage={postMessage} />,
    },
    {
      id: 'blindspot',
      content: (
        <BlindSpot
          blindSpotData={blindSpotData}
          setBlindSpotData={setBlindSpotData}
          blindSpotUpdateMessage={blindSpotUpdateMessage}
          setBlindSpotUpdateMessage={setBlindSpotUpdateMessage}
          postMessage={postMessage}
        />
      ),
    },
    {
      id: 'logmar',
      content: <Logmar logmarType={logmarType} />,
    },
    {
      id: 'randomE',
      content: <RandomE />,
    },
    { id: 'kaysOptotypes', content: <KaysOptotypes /> },
    { id: 'kaysMultiple', content: <KaysMultipleOptotypes /> },
    {
      id: 'optimaChart',
      content: <OptimaChart optimaData={optimaData} />,
    },
    {
      id: 'visualField',
      content: (
        <VisualField
          movementNotification={movementNotification}
          visualFieldTestControl={visualFieldTestControl}
          testNotification={testNotification}
        />
      ),
    },
    {
      id: 'visualFieldTwo',
      content: <VisualFieldTwo />,
    },
    {
      id: 'visualFieldForthValley',
      content: <VisualFieldForthValley />,
    },
    {
      id: 'contrastSensitivity',
      content: <ContrastSensitivity logmarData={logmarData} />,
    },
    {
      id: 'holding',
      content: <Holding />,
    },
    {
      id: 'endOfTest',
      content: <EndOfTest />,
    },
    {
      id: 'refraction',
      content: <Refraction />,
    },
    {
      id: 'refractionTwo',
      content: <RefractionTwo />,
    },
    {
      id: 'pupillaryDistance',
      content: <PupillaryDistance />,
    },
    { id: 'ishihara', content: <ColourVisionPlate /> },
  ];

  const selectedContent = contentOptions.find((selectedTab) => {
    return activeTab === selectedTab.id;
  });

  return activeTab === 'blindspot' ||
    activeTab === 'logmar' ||
    activeTab === 'endOfTest' ||
    activeTab === 'randomE' ||
    activeTab === 'kaysOptotypes' ||
    activeTab === 'kaysMultiple' ||
    activeTab === 'optimaChart' ||
    activeTab === 'contrastSensitivity' ||
    activeTab === 'visualField' ||
    activeTab === 'visualFieldTwo' ||
    activeTab === 'visualFieldForthValley' ||
    activeTab === 'refraction' ||
    activeTab === 'refractionTwo' ||
    activeTab === 'ishihara' ||
    activeTab === 'pupillaryDistance' ||
    activeTab === 'blindspot-camera-calibration' ? (
    selectedContent.content
  ) : (
    <Flex width='100%' bg={theme.colors.background} flexDirection='column'>
      <Flex>
        <PatientSidePanel />
        <Flex justifyContent='center' p=' 20px 20px 20px 0' width='100%'>
          <MainPanel width={activeTab === 'ruler' ? 'calc(100% - 200px)' : '100%'} height='600px' bg={theme.colors.white} title={title}>
            {selectedContent?.content || <Holding />}
          </MainPanel>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default MainPanelContent;
